import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { ChevronDown } from 'react-feather';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { Typography, useTheme } from '@mui/material';
import { useEffect } from 'react';

interface DropdownButtonProps {
    options: any
    handleClick: (index: number) => void
    variant?: "contained" | "outlined"
    title?: string
    selectedOption?: number
    size?: "small" | "large"
    fullWidth?: boolean
}

const DropdownButton: React.FC<DropdownButtonProps> = ({
    options,
    handleClick,
    variant="contained",
    title,
    selectedOption,
    size="small",
    fullWidth=false
}) => {

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  useEffect(() => {
    if(typeof selectedOption !== "undefined") {
      setSelectedIndex(selectedOption);
    }
  }, [selectedOption])

  useEffect(() => {
    if(typeof options !== "undefined" && options?.length) {
      !Boolean(options?.[selectedIndex]) && setSelectedIndex(0);
    }
  }, [options])

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    handleClick(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup 
        variant={variant} 
        ref={anchorRef} 
        aria-label="split button"
        disableElevation
        sx={{ 
          height: '36px',
          width: fullWidth ? "100%" : "fit-content"
         }}>
        { Boolean(title) ? 
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "default",
              borderTopLeftRadius: "8px",
              borderBottomLeftRadius: "8px",
              backgroundColor: theme.palette.background.paper ,
              border: "1px solid #f0f0f0",
              padding: "0rem 0.2rem 0rem 0.5rem",
              borderRight: 0
            }} 
          >
            <Typography 
              variant="body2"
              style={{ 
                fontWeight: 500,
                color: theme.palette.text.secondary
              }}
            >
              {title}
            </Typography>
          </div> 
          : <></> }
        <Button
          variant={variant}
          color={variant !== "contained" ? "secondary" : "primary"}
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="Select create mode"
          aria-haspopup="menu"
          fullWidth={fullWidth}
          onClick={handleToggle}
          sx={{ 
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #f0f0f0", 
            height: size === "small" ? '32px' : '36px', 
            padding: "0.5rem 0.2rem 0.5rem 0.5rem", 
            borderTopLeftRadius: !Boolean(title) ? '8px' : variant !== "contained" ? '0px' : '8px', 
            borderBottomLeftRadius:  !Boolean(title) ? '8px' : variant !== "contained" ? '0px' : "8px", 
            background: '#fff', 
            borderLeft: Boolean(title) ? "1px solid #FFF" : "1px solid #f0f0f0",
            paddingRight: Boolean(title) ? "0.2rem" : "0.5rem" }}
        >
          <span className={`text-[#6E6E6E] ${size === "small" ? 'text-xs': 'text-sm'}`}>{variant === "contained" ? options?.[0]?.label : options?.[selectedIndex]?.label} </span> 
          <ChevronDown className='text-[#6E6E6E] h-4 stroke-[2.5px]'/>
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 999
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        placement='bottom-end'
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              minWidth: '100px',
              width: '100%', 
              transformOrigin:
                placement === 'bottom' ? 'right end' : 'right start',
            }}
          >
            <Paper sx={{ borderRadius: 2 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options?.map((option: any, index: number) => (
                    <MenuItem
                      key={option?.value}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      <Typography
                        variant={"subtitle2"}>
                        {option.label}
                      </Typography>
                      
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default DropdownButton;